// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-user {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center; }
  .add-user__select {
    width: 100%;
    height: 51px;
    border: 1px solid #9e9e9e;
    border-radius: 4px;
    padding: 16px 13px;
    color: #212121;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }
    .add-user__select:focus {
      border-color: #212121;
      outline: none; }
  .add-user__container {
    width: 560px;
    padding: 10px 20px;
    background-color: white;
    border-radius: 5px;
    margin: 30px auto;
    display: flex;
    flex-direction: column; }
    .add-user__container h3 {
      margin-bottom: 30px; }
  .add-user h5 {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px; }
  .add-user label {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }
  .add-user__input {
    width: 100%;
    height: 51px;
    margin-bottom: 50px;
    border: 1px solid #9e9e9e;
    border-radius: 4px;
    padding: 16px 13px;
    color: #212121;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }
    .add-user__input:focus {
      border-color: #212121;
      outline: none; }
  .add-user__footer {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    margin-top: 30px; }
  .add-user__cancel {
    padding: 4px 10px;
    background: #ffffff;
    color: #fe6100;
    border: none;
    cursor: pointer; }
  .add-user__create {
    padding: 4px 10px;
    background: #fe6100;
    color: #ffffff;
    border: none;
    cursor: pointer;
    border-radius: 4px; }
`, "",{"version":3,"sources":["webpack://./src/pages/company/components/addUser.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EACpB;IACC,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;IATjB;MAWE,qBAAqB;MACrB,aAAa,EAAA;EAGf;IACE,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB,EAAA;IAPvB;MASG,mBAAmB,EAAA;EAnCzB;IAuCI,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EAzCrB;IA4CI,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;EAEnB;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;IAVlB;MAYG,qBAAqB;MACrB,aAAa,EAAA;EAGjB;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB,EAAA;EAElB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe,EAAA;EAEjB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,kBAAkB,EAAA","sourcesContent":[".add-user {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n &__select{\n  width: 100%;\n  height: 51px;\n  border: 1px solid #9e9e9e;\n  border-radius: 4px;\n  padding: 16px 13px;\n  color: #212121;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  &:focus {\n    border-color: #212121;\n    outline: none;\n  }\n }\n  &__container {\n    width: 560px;\n    padding: 10px 20px;\n    background-color: white;\n    border-radius: 5px;\n    margin: 30px auto;\n    display: flex;\n    flex-direction: column;\n    h3 {\n      margin-bottom: 30px;\n    }\n  }\n  h5 {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 24px;\n  }\n  label {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n  }\n  &__input {\n    width: 100%;\n    height: 51px;\n    margin-bottom: 50px;\n    border: 1px solid #9e9e9e;\n    border-radius: 4px;\n    padding: 16px 13px;\n    color: #212121;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    &:focus {\n      border-color: #212121;\n      outline: none;\n    }\n  }\n  &__footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    margin-top: 30px;\n  }\n  &__cancel {\n    padding: 4px 10px;\n    background: #ffffff;\n    color: #fe6100;\n    border: none;\n    cursor: pointer;\n  }\n  &__create {\n    padding: 4px 10px;\n    background: #fe6100;\n    color: #ffffff;\n    border: none;\n    cursor: pointer;\n    border-radius: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
